export enum ActionSocket {
    UpdateStatus = "SOCKET_STATUS_UPDATE"
}